<ng-container *transloco="let t">
<div class="card">
  <div class="card-header d-flex align-items-center justify-content-center">
    <h5 class="opacity-80">{{ t('portal.borrowers.title') }}</h5>
  </div>
  <div class="card-body">
    <div class="row">
      @for (borrower of loanBorrowers; track borrower.borrowerId) {
        <div class="row my-2">
          @if (borrower.borrowerId) {
            <div
              class="col-4 d-flex align-items-center justify-content-center"
            >
              <span
                class="bp-contact-name-circle p-2 rounded-circle fw-bold d-flex align-items-center justify-content-center"
              >
                {{ borrower.borrowerName?.charAt(0) }}
              </span>
            </div>
          }
          <div class="col-8">
            <div class="opacity-80 fw-bold">{{ borrower.borrowerName }}</div>
            @if (borrower.borrowerId) {
              <div>
                <span class="me-4" >
                  <a class="nav-link d-inline" href="tel:{{borrower.borrowerPhone}}"><i class="fa fa-phone"></i> {{ t('portal.borrowers.call') }}</a>
                </span>
                <span>
                  <a class="nav-link d-inline" href= "mailto: {{borrower.borrowerEmail}}"><i class="fa fa-envelope"></i> {{ t('portal.borrowers.email') }}</a>
                </span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>

</div>
</ng-container>
